import React from 'react';
import { observer } from 'mobx-react';

import { Content } from '../Content/Content.js';
import { Dropdown } from '../Dropdown/Dropdown.js';
import { useStores } from '../hooks/useStores.js';
import { TabsStore } from '../Tabs/stores/TabsStore.js';
import TabPanel from '../Tabs/TabPanel.js';
import { Tabs } from '../Tabs/Tabs.js';

import { AppStore } from './stores/AppStore.js';

type TDisplayModeProps = {};

export const DisplayMode: React.FC<TDisplayModeProps> = observer(() => {
	const { isSnapshot, displayMode, getTranslateFunction } = useStores<AppStore>('appStore');
	const {
		activeTabIndex: activeIndexInitial,
		onChange,
		setActiveTab,
		tabKeys,
		tabsProps,
	} = useStores<TabsStore>('tabsStore');
	const { tabComponents: items, options } = tabsProps;
	const [activeIndex, setActiveIndex] = React.useState(activeIndexInitial);

	const handleChange = (value: number) => {
		setActiveIndex(value);
		setActiveTab(tabKeys[value]);
		if (onChange) {
			onChange(tabKeys[value]);
		}
	};

	const translateFn = getTranslateFunction();
	const getLabel = (header: string) => {
		return translateFn ? translateFn(header) : header;
	};

	const props = {
		activeIndex,
		handleChange,
		items: items,
		getLabel,
		options,
	};

	const contentComponent = items.map(({ tabKey, grid }, index) => {
		const content = (isSnapshot || activeIndex === index) && (
			<Content key={`${tabKey}-content-${index}`} currentGrid={grid} tabKey={tabKey} />
		);
		if (displayMode === 'tabs') {
			return (
				<TabPanel key={`${tabKey}-panel-${index}`} value={activeIndex} index={index}>
					{content}
				</TabPanel>
			);
		}
		return content;
	});

	if (displayMode === 'dropdown') {
		return <Dropdown {...props}>{contentComponent}</Dropdown>;
	} else {
		return <Tabs {...props}>{contentComponent}</Tabs>;
	}
});
